var _path, _circle, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEventsLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 257,
    height: 257,
    viewBox: "0 0 257 257",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M128.89 256.78C199.582 256.78 256.89 199.472 256.89 128.78C256.89 58.0876 199.582 0.780029 128.89 0.780029C58.1976 0.780029 0.890015 58.0876 0.890015 128.78C0.890015 199.472 58.1976 256.78 128.89 256.78Z",
    fill: "#00BCDA"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 128.89,
    cy: 128.78,
    r: 94.1714,
    stroke: "#00BCDA",
    strokeWidth: 9.14286
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M151.767 116.244C151.767 128.644 141.714 138.697 129.313 138.697C116.913 138.697 106.86 128.644 106.86 116.244C106.86 103.843 116.913 93.7904 129.313 93.7904C141.714 93.7904 151.767 103.843 151.767 116.244Z",
    stroke: "#00BCDA",
    strokeWidth: 8.88163
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M109.07 152.103L109.063 152.098L109.056 152.094C99.6563 145.983 94.0315 136.87 92.1314 125.591L91.5075 121.888H87.7522H67.1208H62.4689L62.6848 126.535C63.5637 145.456 75.6985 168.706 98.7282 180.196L98.7413 180.202L98.7544 180.209C122.916 192.066 147.044 190.316 169.072 174.493C184.989 163.097 193.57 147.018 195.874 127.584L196.462 122.62H191.464H170.79H167.116L166.427 126.228C164.463 136.52 159.721 143.737 153.573 148.51C147.397 153.304 139.531 155.836 131.035 156.229C122.391 156.183 114.927 155.941 109.07 152.103Z",
    stroke: "#00BCDA",
    strokeWidth: 8.88163
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEventsLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/eventsLogo.41d57d2ffee0e24effb8a2d911bba014.svg";